import { Product, ProductType, RoofLightProduct } from '../';

export function IsRoofLightProduct(product: Product): product is RoofLightProduct {
  return (product as RoofLightProduct).productType === ProductType.ROOF_LIGHT;
}
